import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteProgramDocument: (
  fetchContext: FetchContext,
  programDocumentId: number,
  accessToken?: string,
) => Promise<void> = async (fetchContext, programDocumentId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/program-documents/${programDocumentId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete program document'));
